import { defaultLocale } from '@adsk/alloy-react-locale';

import { FirstDayOfWeek } from '../types';

// ts supports Locale, but not the weekInfo property yet, not even in ESNEXT
type LocaleWithWeekInfo = Intl.Locale & {
  weekInfo?: { firstDay?: number };
};

export const LOCALE_TO_FIRST_DAY_OF_WEEK: Record<string, FirstDayOfWeek> = {
  'fr-CA': 0,
  da: 1,
  es: 1,
  fi: 1,
  ru: 1,
  'zh-Hans': 1,
  hr: 1,
  fr: 1,
  nl: 1,
  ja: 0,
  ca: 1,
  hu: 1,
  it: 1,
  pl: 1,
  cs: 1,
  'pt-BR': 0,
  'en-GB': 1,
  de: 1,
  ro: 1,
  'zh-Hant': 0,
  ko: 0,
  tr: 1,
  'pt-PT': 0,
  en: 0,
  [defaultLocale]: 0,
  sv: 1,
  no: 1,
  'zh-Hant-HK': 0,
};

// 7 and 0 are equivalent for Sunday as first day of week, the Intl api uses 7, but we
// prefer to always use 0
const clamp = (num = 0) => (num >= 7 ? 0 : num);

// Intl.Locale.WeekInfo has partial support in browsers, the Locale polyfill from @formatjs
// doesn't polyfill the property we need.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl
//   /Locale/weekInfo#browser_compatibility
const getFirstDayOfWeek = (locale?: string, firstDayOfWeekProp?: number) => {
  if (typeof firstDayOfWeekProp === 'number') return clamp(firstDayOfWeekProp);
  try {
    const isFunction = typeof Intl.Locale === 'function';

    const { weekInfo }: LocaleWithWeekInfo = isFunction
      ? // Required for https://git.autodesk.com/BIM360/alloy-react/pull/1901
        // @ts-expect-error Intl.Locale is a function in ES2015 target but TS doesn't agree
        Intl.Locale(locale ?? defaultLocale)
      : new Intl.Locale(locale ?? defaultLocale);

    return clamp(
      weekInfo?.firstDay ??
        LOCALE_TO_FIRST_DAY_OF_WEEK[locale ?? defaultLocale],
    );
  } catch (e) {
    return clamp(LOCALE_TO_FIRST_DAY_OF_WEEK[locale ?? defaultLocale]);
  }
};

export default getFirstDayOfWeek;
